




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RatingsStars extends Vue {
	@Prop({ default: 5})
	private rating!: number;

	@Prop()
	private starsColor?: string;

	get starsStyles():string {
		if (this.starsColor) {
			const ratingsVar = `--rating: ${this.rating};`;
			const colorVar = `--star-background: ${this.starsColor}`;
			return ratingsVar + colorVar;
		}
		return `--rating: ${this.rating}`;
	}
}
